import { logout } from '@/api/loginApi';
export default {
  state: {
    userInfo: {},
    permissions: [],
    roles: [],
    modulePower: {},//模块权限
    depotList: [],//仓库数据
    DeviceType: 1,//选中仪器类型
    DepotId: '',//选中仓库
    cabinetInfo: [],//仪器柜格口信息
    powerInfo: [],//电源控制器信息
    router: [],// 路由
    deptName: '',//当前用户所属单位
    deptLogo: '',//单位logo
    Authorization: sessionStorage.getItem('Authorization') ? sessionStorage.getItem('Authorization') : ''
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_TOKEN(state, token) {
      state.Authorization = token;
      sessionStorage.setItem('Authorization', token);
    },
    SET_DEPOT_LIST(state, depotList) {
      state.depotList = depotList
    },
    SET_CABINET_INFO(state, cabinetInfo) {
      state.cabinetInfo = cabinetInfo
    },
    SET_POWER_INFO(state, powerInfo) {
      state.powerInfo = powerInfo
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_ROLE_INFO(state, roles) {
      state.roles = roles
    },
    SET_ROUTERS(state, router) {
      state.router = router
    },
    SET_MODULES(state, modulePower) {
      state.modulePower = modulePower
    },
    SET_DEPTNAME(state, deptName) {
      state.deptName = deptName
    },
    SET_DEPTLOGO(state, deptLogo) {
      state.deptLogo = deptLogo
    },
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    setToken({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    setDepotList({ commit }, data) {
      commit('SET_DEPOT_LIST', data)
    },
    setCabinetInfo({ commit }, data) {
      commit('SET_CABINET_INFO', data)
    },
    setPowerInfo({ commit }, data) {
      commit('SET_POWER_INFO', data)
    },
    setPermissions({ commit }, data) {
      commit('SET_PERMISSIONS', data)
    },
    setRoles({ commit }, data) {
      commit('SET_ROLE_INFO', data)
    },
    setRouters({ commit }, data) {
      commit('SET_ROUTERS', data)
    },
    setModules({ commit }, data) {
      commit('SET_MODULES', data)
    },
    setDeptName({ commit }, data) {
      commit('SET_DEPTNAME', data)
    },
    setDeptLogo({ commit }, data) {
      commit('SET_DEPTLOGO', data)
    },
    // 退出登录
    Logout({ commit }) {
      return new Promise((resolve, reject) => { // 退出登录
        logout().then(() => {
          commit('SET_TOKEN', '');
          commit('SET_PERMISSIONS', []);
          commit('SET_ROLE_INFO', []);
          commit('SET_MODULES', {});
          sessionStorage.clear();
          localStorage.clear();
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出   同样是在action中管理
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        sessionStorage.removeItem('Authorization')
      })
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js